/**
 * One shimmering placeholder, the size of the thing it stands in for. A skeleton is made of these.
 */
export const Bone = ({
    width,
    height,
    block = false,
    round = false,
}: {
    width?: number | string;
    height: number;
    /** Full width of its container. */
    block?: boolean;
    /** A disc — a face's stand-in. */
    round?: boolean;
}) => (
    <span
        className={`sd-bone${round ? ' sd-bone-round' : ''}`}
        style={{width: block ? '100%' : width, height}}
    />
);
